<template>
  <div class="yh-page">
    <el-card>
      <el-tabs v-model="activeName">
        <el-tab-pane name="MemberApply">
          <span slot="label">
            <el-badge :value="member_count" style="height: 70px; top: 10px;; position: relative;">
              会员入会申请(准会员)
            </el-badge>
          </span>
          <member-apply ref="member"></member-apply>
        </el-tab-pane>
        <el-tab-pane name="ShipApply">
          <span slot="label">
            <el-badge :value="ship_count" style="height: 70px; top: 10px;; position: relative;">
              船舶入会申请(准入会船舶)
            </el-badge>
          </span>
          <ship-apply ref="ship"></ship-apply>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import MemberApply from './apply'
import ShipApply from './ship-apply-list'

export default {
  components: {
    MemberApply,
    ShipApply
  },
  data() {
    return {
      activeName: 'MemberApply',
      member_count: 0,
      ship_count: 0
    }
  },
  methods: {
    getMemberCount(val) {
      this.member_count = val
    },
    getShipCount(val) {
      this.ship_count = val
    },
  },
  mounted() {
    this.$refs.member.$on("toIndex", this.getMemberCount);
    this.$refs.ship.$on("toIndex", this.getShipCount)
  }
}
</script>